import { ContactSubmitService } from "./service";

import { CONTACT_SUBMIT_DATA } from "../../common/constants/actionConstants";

import { isLoading } from "../../common/dependencies/action/action";
import { toast } from "react-toastify";

import swal from 'sweetalert';
export const contactSubmitData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    //
    const { contactSubmitData } = data;
    if (contactSubmitData) {
      dispatch({
        type: CONTACT_SUBMIT_DATA,
        payload: contactSubmitData,
      });
      
      swal("Thank you", "Your query has been submitted successfully.", 
      "success",
      {closeOnClickOutside: false}
);
    // toast.success("Your query has been submitted successfully ");
    }
    dispatch(isLoading(false));
    // toast.error(data?.data?.errors[0]?.message);
  });
};

async function getBindData(params) {
  const contactSubmitData = await ContactSubmitService.contactSubmitData(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });

  return {
    contactSubmitData,
  };
}
